import { useTranslation } from 'react-i18next'

import { ReveniAiButton, Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const StartStep = ({ onStart }) => {
  const { t } = useTranslation()

  return (
    <Styles.Container>
      <Text type="bodyMRegular">
        {t(
          'Los artículos de inventario seleccionados serán analizados para generar recomendaciones de clasificación aduanera y datos de producto. Dependiendo de la cantidad de artículos, este proceso puede demorar unos minutos. ¿Deseas continuar?'
        )}
      </Text>
      <ReveniAiButton label={t('Comenzar')} onClick={onStart} fullWidth />
    </Styles.Container>
  )
}

export default StartStep
